import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isDuplicateProjectRequestFailure(projectModel, zone) {
      const req = getState().find(
        (req) =>
          req.sourceProject.uuid === projectModel.uuid &&
          req.zone.uuid === zone.uuid,
      );

      return req ? req.request.isFailure : false;
    },
    isDuplicateProjectRequestPending(projectModel, zone) {
      const req = getState().find(
        (req) =>
          req.sourceProject.uuid === projectModel.uuid &&
          req.zone.uuid === zone.uuid,
      );

      return req ? req.request.isPending : false;
    },
    isDuplicateProjectRequestSuccess(projectModel, zone) {
      const req = getState().find(
        (req) =>
          req.sourceProject.uuid === projectModel.uuid &&
          req.zone.uuid === zone.uuid,
      );

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
